import { render, staticRenderFns } from "./EditCardModal.vue?vue&type=template&id=1ccfc46a&scoped=true&"
import script from "./EditCardModal.vue?vue&type=script&lang=js&"
export * from "./EditCardModal.vue?vue&type=script&lang=js&"
import style0 from "./EditCardModal.vue?vue&type=style&index=0&id=1ccfc46a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccfc46a",
  null
  
)

export default component.exports